// frontend/src/components/common/GlobalOverlay/index.js
import React, { useEffect, useState, useMemo } from 'react';
import { createPortal } from 'react-dom';
import useAuthStore from '../../../store/authStore';
import useAnnouncementStore from '../../../store/announcementStore';
import PromotionBanner from './PromotionBanner';
import AnnouncementBanner from './AnnouncementBanner';

const GlobalOverlay = () => {
  const { isAuthenticated } = useAuthStore();
  const { getActiveAnnouncements, getCurrentPromotion } = useAnnouncementStore();
  const [isLoaded, setIsLoaded] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      loadData();
    } else {
      setIsLoaded(false);
    }
  }, [isAuthenticated]);

  const loadData = async () => {
    try {
      await Promise.all([
        getActiveAnnouncements(),
        getCurrentPromotion(),
      ]);
      setIsLoaded(true);
    } catch (error) {
      console.error('Failed to load overlay data:', error);
    }
  };

  if (!mounted || !isAuthenticated || !isLoaded) {
    return null;
  }

  // Use portal to render at the root level
  return createPortal(
    <div 
      className="fixed inset-0 pointer-events-none z-[9999]"
      style={{ pointerEvents: 'none' }}
    >
      {/* Promotion Banner - Top */}
      <div className="absolute top-0 left-0 right-0 pointer-events-none px-3 pt-2">
        <div className="pointer-events-auto max-w-4xl mx-auto">
          <PromotionBanner />
        </div>
      </div>

      {/* Announcement Banner - Bottom */}
      <div className="absolute bottom-[72px] left-0 right-0 pointer-events-none px-3">
        <div className="pointer-events-auto max-w-4xl mx-auto">
          <AnnouncementBanner />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default GlobalOverlay;